import * as React from 'react'
import {FC, useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {RootState} from '../../store/reducers'
import * as moment from 'moment/moment'
import {useForm} from 'antd/lib/form/Form'
import {Form, Row, Col, Select, InputNumber, Button, Switch, DatePicker, notification} from 'antd'
import Location from '../location'
import Owner from '../owner'
import {KiasDataRepresentationInterface} from '../../types/responses/data-for-render'
import * as FIELDS from '../../constants/fields'
import {OUTPUT_DATE_FORMAT} from '../../../../common/constants'
import {useGetCostLazy} from '../../store/api/express-api'
import {Extractor} from '../../classes/Extractor'
import {formatRates} from '../../helpers/format-rates'
import KIAS_COUNTRIES from '../../constants/countries'
import {Moment} from 'moment'
import './index.less'

const {Item} = Form
const {Option} = Select

interface CalculatorPropsInterface {
    initValues?: object
}

const Calculator: FC<CalculatorPropsInterface> = ({initValues}) => {
    const [form] = useForm()
    const regions = useSelector((state: RootState) => state.regions)
    const dataForRender = useSelector((state: RootState) => state.dataForRender)
    const [calculate, calculateState] = useGetCostLazy()
    const [insPeriodIsn, setInsPeriodIsn] = useState<number | null>(null)
    const [beginDate, setBeginDate] = useState<Moment>(moment())
    const [regionCode, setRegionCode] = useState<string>(
        form.getFieldValue(FIELDS.REGION.name) ?? ''
    )

    useEffect(() => {
        if (calculateState.isError) {
            const {data} = calculateState.error

            let description = null;
            switch (true) {
                case data === null:
                    break;
                case Array.isArray(data):
                    description = data.join(", ")
                    break;
                case typeof data === 'object':
                    const parts: string[] = [];
                    for (const key in data) {
                        parts.push(`"${key}": ${data[key]}`)
                    }
                    description = parts.join(", ")
                    break;
                default:
                    description = data
            }

            console.log("description", description)

            notification['error']({
                message: 'Произошла ошибка',
                description: description,
                placement: 'bottomRight',
            })
        }
    }, [calculateState]);

    const renderList = (data: KiasDataRepresentationInterface[]) => {
        if (data && data.length > 0) {
            return data.map(element => (
                <Option value={element.isn} key={element.isn} style={{whiteSpace: 'normal'}}>
                    {element.value}
                </Option>
            ))
        } else return null
    }

    const handleCalculate = async () => {
        await form.validateFields()

        const data = new Extractor(form).extract()
        calculate(data)
    }

    const handleSelectStartDate: (value: Moment) => void = (value) => {
        setBeginDate(value.clone())
        form.resetFields([FIELDS.DATE_END.name])
    }

    const checkUnavailableEndDate: (value: Moment) => boolean = (value) => {
        if (!beginDate) {
            return true
        }

        return value < beginDate || value > beginDate.clone().add(90, 'days')
    }

    return (
        <Form form={form} className='calc' layout={'vertical'} initialValues={initValues}>
            <Row gutter={16} justify={'center'}>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Item {...FIELDS.VEHICLE_REGISTRATION_COUNTRY}>
                        <Select
                            size='large'
                            showSearch={true}
                            className='calc-territory'
                            optionFilterProp='children'
                            placeholder={'Введите страну...'}
                            dropdownStyle={{
                                minHeight: '250px',
                            }}
                        >
                            {KIAS_COUNTRIES.map(item => (
                                <Option key={item.isn} value={item.isn}>
                                    {item.value}
                                </Option>
                            ))}
                        </Select>
                    </Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Item {...FIELDS.OWNER_REGISTRATION_COUNTRY}>
                        <Select
                            size='large'
                            showSearch={true}
                            className='calc-territory'
                            optionFilterProp='children'
                            placeholder={'Введите страну...'}
                            dropdownStyle={{
                                minHeight: '250px',
                            }}
                        >
                            {KIAS_COUNTRIES.map(item => (
                                <Option key={item.isn} value={item.isn}>
                                    {item.value}
                                </Option>
                            ))}
                        </Select>
                    </Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={4}>
                    <Item {...FIELDS.DRIVING_EXPERIENCE}>
                        <Select size='large' className='calc-select' optionFilterProp='children'>
                            {renderList(dataForRender.drivingExperience)}
                        </Select>
                    </Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={4}>
                    <Item {...FIELDS.POWER}>
                        <Select size='large' className='calc-select' optionFilterProp='children'>
                            {renderList(dataForRender.enginePower)}
                        </Select>
                    </Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Owner />
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                    <Item {...FIELDS.REGION}>
                        <Select
                            size='large'
                            showSearch={true}
                            className='calc-territory'
                            optionFilterProp='children'
                            placeholder={'Введите регион...'}
                            onChange={value => {
                                setRegionCode(value.toString())
                                form.resetFields([FIELDS.LOCATION.name])
                            }}
                            dropdownStyle={{
                                minHeight: '250px',
                            }}
                        >
                            {regions.map(item => (
                                <Option key={item.isn} value={item.guid}>
                                    {item.name}
                                </Option>
                            ))}
                        </Select>
                    </Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={8}>
                    <Location code={regionCode} />
                </Col>
                <Col xs={24} sm={12} md={8} lg={7}>
                    <Item {...FIELDS.VEHICLE_TYPE}>
                        <Select size='large' className='calc-select' optionFilterProp='children'>
                            {renderList(dataForRender.vehicleType)}
                        </Select>
                    </Item>
                </Col>
                <Col xs={24} sm={12} md={4} lg={3}>
                    <Item
                        {...FIELDS.KBM}
                        tooltip={{
                            title: (
                                <span>
                                    Скидка на безаварийное вождение, вы можете узнать данный
                                    коэффициент здесь:{' '}
                                    <a
                                        target='_blank'
                                        style={{color: '#5662a8'}}
                                        href='https://dkbm-web.autoins.ru/dkbm-web-1.0/kbm.htm'
                                        rel='nofollow'
                                    >
                                        https://dkbm-web.autoins.ru/dkbm-web-1.0/kbm.htm
                                    </a>
                                </span>
                            ),
                        }}
                    >
                        <InputNumber
                            formatter={value => `${value}`.replace('.', ',')}
                            parser={value => value.replace(',', '.')}
                            style={{width: '100%'}}
                            size='large'
                        />
                    </Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                    <Item {...FIELDS.PERIOD}>
                        <Select size='large' className='calc-select' optionFilterProp='children' onSelect={setInsPeriodIsn}>
                            {renderList(dataForRender.insurancePeriod)}
                        </Select>
                    </Item>
                </Col>
                <Col xs={24} sm={12} md={4} lg={4}>
                    <Item {...FIELDS.CALC_DATE}>
                        <DatePicker
                            size='large'
                            disabledDate={current => current < moment().add(-1, 'days')}
                            format={OUTPUT_DATE_FORMAT}
                            onChange={handleSelectStartDate}
                        />
                    </Item>
                </Col>

                {/* показываем, если выбрано менее 3 мес (для резидентов) */}
                {(insPeriodIsn === 9666451) && (
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <Item {...FIELDS.DATE_END}>
                            <DatePicker
                                size='large'
                                disabledDate={checkUnavailableEndDate}
                                format={OUTPUT_DATE_FORMAT}
                            />
                        </Item>
                    </Col>
                )}

                <Col xs={12} sm={12} md={8} lg={6}>
                    <Item {...FIELDS.UNLIMITED_DRIVERS_LIST}>
                        <Switch />
                    </Item>
                </Col>
                <Col xs={12} sm={12} md={8} lg={2}>
                    <div className='centered-switch'>
                        <Item {...FIELDS.TRAILER}>
                            <Switch />
                        </Item>
                    </div>
                </Col>
            </Row>

            {calculateState.data?.data?.cost && (
                <>
                    <Row justify={'center'}>
                        <Col sm={24} xs={24}>
                            <div className={`calc-rates`}>
                                <span>
                                    Коэффициенты: <br />
                                </span>
                                <span>{formatRates(calculateState.data.data.details)}</span>
                            </div>
                        </Col>
                    </Row>
                    <Row justify={'center'}>
                        <Col className={'calc-control-wrap__item calc-cost'}>
                            {`${calculateState.data.data.cost} руб.`}
                        </Col>
                    </Row>
                </>
            )}

            <Row justify={'center'}>
                <Col>
                    <Item>
                        <Button
                            size={'large'}
                            onClick={handleCalculate}
                            type={'primary'}
                            loading={calculateState.isFetching}
                        >
                            {calculateState.data?.data?.cost ? 'Пересчитать' : 'Рассчитать'}
                        </Button>
                    </Item>
                </Col>
                {ENV_IS_DEV && (
                    <Col>
                        <Item>
                            <Button
                                size={'large'}
                                onClick={() => console.log(form.getFieldsValue())}
                            >
                                Данные формы
                            </Button>
                        </Item>
                    </Col>
                )}
            </Row>
        </Form>
    )
}

Calculator.defaultProps = {
    initValues: {
        calcDate: moment(),
        legalPerson: false,
        registeredAbroad: false,
        kbm: 1,
        unlimitedDriversList: true,
        trailer: false,
    },
}

export default Calculator
